// extracted by mini-css-extract-plugin
export default {"container":"Options_container__7yQRl","length":"Options_length__sOOyd","bold":"Options_bold__rcWT-","generateBtn":"Options_generateBtn__Dh8W7"};